var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('info-section-card',{attrs:{"fields":_vm.fields,"data":_vm.data},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('h4',{staticClass:"blue-text"},[_vm._v(_vm._s(_vm.L10n('po')))])]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }